export const NavCommonProps = {
  buttonItem: {
    mb: 0.5,
    borderRadius: 0,
  },
};
